// extracted by mini-css-extract-plugin
export default {"wrapper":"MOU483RpJl0xMTLkhC0Q"};